import { useState, useEffect, useCallback } from "react";

/**
 * Custom hook to decode JWT token and get user info
 */
export function useAuthToken() {
  const [token, setToken] = useState(localStorage.getItem("access_token"));
  const [payload, setPayload] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState(null);

  // Decode token
  const decodeToken = useCallback((jwt) => {
    try {
      const decoded = JSON.parse(atob(jwt.split(".")[1]));
      setPayload(decoded);
      setRole(decoded.role || null);
      setIsAdmin(decoded.role === "admin");
    } catch (err) {
      console.error("Token decode failed:", err);
      setPayload(null);
      setRole(null);
      setIsAdmin(false);
      localStorage.removeItem("access_token");
    }
  }, []);

  // Handle login
  const handleLogin = useCallback((jwt) => {
    localStorage.setItem("access_token", jwt);
    setToken(jwt);
    decodeToken(jwt);
  }, [decodeToken]);

  // Handle logout
  const handleLogout = useCallback(() => {
    localStorage.removeItem("access_token");
    setToken(null);
    setPayload(null);
    setRole(null);
    setIsAdmin(false);
  }, []);

  // Decode on mount if token exists
  useEffect(() => {
    if (token) decodeToken(token);
  }, [token, decodeToken]);

  return { token, payload, role, isAdmin, handleLogin, handleLogout };
}
